"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var student_waitlist_html_1 = __importDefault(require("./student-waitlist.html"));
var student_waitlist_controller_1 = __importDefault(require("./student-waitlist.controller"));
function getCourseTypes(CourseTypesModel) {
    return CourseTypesModel.get().then(function (response) {
        return response.courseTypes;
    });
}
getCourseTypes.$inject = ["CourseTypesModel"];
function getSessionTypes(DriveSessionTypesModel) {
    return DriveSessionTypesModel.get().then(function (response) {
        return response.sessionTypes;
    });
}
getSessionTypes.$inject = ["DriveSessionTypesModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.student.waitlist", {
        url: "/waitlist",
        controller: "StudentWaitlistController",
        controllerAs: "vm",
        template: student_waitlist_html_1.default,
        resolve: {
            sessionTypes: getSessionTypes,
            courseTypes: getCourseTypes,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.student,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("student.waitlist", [])
    .config(config)
    .controller("StudentWaitlistController", student_waitlist_controller_1.default);
